import type {
  AutocompleteGameCardsRequest,
  GameCardPrintingsQuery,
} from "modules/cards/model/card";
import type { PricingConfiguration } from "modules/common/model/models";
import { API_ROUTES } from "utils/api-route.constants";

type AutocompleteQuery = AutocompleteGameCardsRequest & PricingConfiguration;
type PrintingsQuery = GameCardPrintingsQuery & PricingConfiguration;

/**
 * Public catalogue reads must carry every result dimension in the URL so the
 * browser, API edge, and Next.js data cache all key the same response.
 */
export function buildCardAutocompleteUrl(req: AutocompleteQuery): string {
  const params = new URLSearchParams({
    string: req.string,
    page_size: String(req.pageSize),
    page: String(req.page),
    foil: String(req.foil),
    playable: String(req.playable),
    market: req.market,
    currency: req.currency,
  });

  if (req.game) params.set("game", req.game);
  if (req.setCode) params.set("set_code", req.setCode);
  if (req.format) params.set("format", req.format);
  if (req.rarity) params.set("rarity", req.rarity);

  return `${API_ROUTES.MAGIC_CARDS.AUTOCOMPLETE}?${params.toString()}`;
}

export function buildCardPrintingsUrl(
  cardId: string,
  req: PrintingsQuery
): string {
  const params = new URLSearchParams({
    per_page: String(req.perPage),
    page: String(req.page),
    include_self: String(req.includeSelf ?? false),
    market: req.market,
    currency: req.currency,
  });

  if (req.sort) params.set("sort", req.sort);
  if (req.order) params.set("order", req.order);

  return `${API_ROUTES.MAGIC_CARDS.PRINTINGS(cardId)}?${params.toString()}`;
}
